import { useEffect, useState } from "react";

/**
 * 
 * @returns true if component is rendered on client side
 */
export const useClientOnly = (): boolean => {
    const [isClient, setIsClient] = useState(false);
    useEffect(() => {
        setIsClient(true);
    }, []);
    
    return isClient;
}